import {
	doRequest
} from "./http";

let baseApiHttp = {
	// 获取专题
	index$get_special: ({
		page,
		limit,
		group_id,
		subject_id,
		course_type_id,
		price
	}) => {
		return doRequest("GET", {
			url: "index/get_special",
			params: {
				page,
				limit,
				group_id,
				subject_id,
				course_type_id,
				price
			},
		});
	},
	// 获取首页的课程
	index$getIndexCourse: () => {
		return doRequest("GET", {
			url: "index/getIndexCourse",
		});
	},
	// 获取课程查询条件
	index$getCourseSeachType: () => {
		return doRequest("GET", {
			url: "index/getCourseSeachType",
		});
	},
	// 获取课程列表
	index$get_course: ({
		page,
		limit,
		subject_id,
		course_type_id,
		special_id,
		teacher,
		price,
		seach_text,
		is_free,
		create_at,
		tag,
		price_sort,
	}) => {
		return doRequest("GET", {
			url: "index/get_course",
			params: {
				page,
				limit,
				subject_id,
				course_type_id,
				special_id,
				teacher,
				price,
				seach_text,
				is_free,
				create_at,
				tag,
				price_sort,
			},
		});
	},
	// 根据课程类别获取课程
	index$get_course_by_type: ({
		course_type_id
	}) => {
		return doRequest("GET", {
			url: "index/get_course_by_type",
			params: {
				course_type_id
			},
		});
	},
	// 获取课程小节
	index$getCourseList: ({
		course_id
	}) => {
		return doRequest("GET", {
			url: "index/getCourseList",
			params: {
				course_id
			},
		});
	},
	// 获取专题详情
	index$get_special_detail: ({
		id
	}) => {
		return doRequest("GET", {
			url: "index/get_special_detail",
			params: {
				id
			},
		});
	},
	// 获取老师详情
	index$getTeacherDetail: ({
		teacher_id
	}) => {
		return doRequest("GET", {
			url: "index/getTeacherDetail",
			params: {
				teacher_id
			},
		});
	},
	// 购课须知
	index$getGuide: ({
		type
	}) => {
		return doRequest("GET", {
			url: "index/getGuide",
			params: {
				type
			},
		});
	},
	// 领取免费课程
	index$receiveCourse: ({
		user_id,
		course_id,
		special_id
	}) => {
		return doRequest("POST", {
			url: "index/receiveCourse",
			body: {
				user_id,
				course_id: course_id || '',
				special_id: special_id || ''
			},
		});
	},
	// 下单
	order$putOrder: ({
		user_id,
		course_id,
		special_id
	}) => {
		return doRequest("POST", {
			url: "order/putOrder",
			body: {
				user_id,
				course_id,
				special_id
			},
		});
	},
	// 会员卡下单
	order$putCardOrder: ({
		user_id,
		id,
	}) => {
		return doRequest("POST", {
			url: "order/putCardOrder",
			body: {
				user_id,
				id
			},
		});
	},
	// 支付
	order$payOrder: ({
		id,
		openid,
		pay_type,
		user_coupon_id,
		score
	}) => {
		return doRequest("POST", {
			url: "order/payOrder",
			body: {
				id,
				openid,
				pay_type,
				user_coupon_id,
				score
			},
		});
	},
	// 会员卡支付
	order$payCardOrder: ({
		id,
		openid,
		pay_type,
	}) => {
		return doRequest("POST", {
			url: "order/payCardOrder",
			body: {
				id,
				openid,
				pay_type,
			},
		});
	},
	// 获取订单支付状态
	order$getOrderStatus: ({
		id,
		order_type
	}, showErr) => {
		return doRequest("GET", {
			url: "order/getOrderStatus",
			params: {
				id,
				order_type
			},
		}, showErr);
	},
	// 获取我的订单
	order$getOrder: ({
		user_id,
		status
	}) => {
		return doRequest("GET", {
			url: "order/getOrder",
			params: {
				user_id,
				status
			},
		});
	},
	//获取订单详情
	order$get_order_detail: ({
		id,
	}) => {
		return doRequest("GET", {
			url: "order/get_order_detail",
			params: {
				id,
			},
		});
	},
	//获取会员订单详情
	order$get_card_orders_detail: ({
		id,
	}) => {
		return doRequest("GET", {
			url: "order/get_card_orders_detail",
			params: {
				id,
			},
		});
	},
	// 获取会员卡订单
	order$get_card_orders: ({
		user_id
	}) => {
		return doRequest("GET", {
			url: "order/get_card_orders",
			params: {
				user_id
			},
		});
	},
	// 收藏
	index$collect: ({
		user_id,
		course_id,
		special_id,
		articles_id
	}) => {
		return doRequest("POST", {
			url: "index/collect",
			body: {
				user_id,
				course_id: course_id || '',
				special_id: special_id || '',
				articles_id: articles_id || '',
			},
		});
	},
	// 获取我的收藏
	user$getCollection: ({
		user_id,
		type_list,
		page,
		limit,
	}) => {
		return doRequest("GET", {
			url: "user/getCollection",
			params: {
				user_id,
				type_list,
				page,
				limit,
			},
		});
	},
	//获取我的专题
	index$get_my_special: ({
		user_id,
		order_id
	}) => {
		return doRequest("GET", {
			url: "index/get_my_special",
			params: {
				user_id,
				order_id
			},
		});
	},
	// 获取我的课程
	index$get_user_course: ({
		user_id,
		special_id
	}) => {
		return doRequest("GET", {
			url: "index/get_user_course",
			params: {
				user_id,
				special_id
			},
		});
	},
	// 获取的我的团队成员
	user$getMyTeam: ({
		user_id
	}) => {
		return doRequest("GET", {
			url: "user/getMyTeam",
			params: {
				user_id
			},
		});
	},
	// 获取优作首页分类
	index$getArticleDesc: () => {
		return doRequest("GET", {
			url: "index/getArticleDesc",
		});
	},
	// 获取学员优作文章
	index$getStudenArticle: ({
		page,
		limit,
		group_id
	}) => {
		return doRequest("GET", {
			url: "index/getStudenArticle",
			params: {
				page,
				limit,
				group_id
			},
		});
	},
	// 获取推荐优作
	index$getSuggestArticle: () => {
		return doRequest("GET", {
			url: "index/getSuggestArticle",
		});
	},
	// 学员优作详情
	index$getStudenArticleDetail: ({
		article_id
	}) => {
		return doRequest("GET", {
			url: "index/getStudenArticleDetail",
			params: {
				article_id
			},
		});
	},
	// 文章点赞
	index$addLikes: ({
		user_id,
		article_id
	}) => {
		return doRequest("POST", {
			url: "index/addLikes",
			body: {
				user_id,
				article_id
			},
		});
	},
	// 文章评论
	index$addComment: ({
		user_id,
		article_id,
		parent_id,
		content
	}) => {
		return doRequest("POST", {
			url: "index/addComment",
			body: {
				user_id,
				article_id,
				parent_id,
				content
			},
		});
	},
	// 获取优作评论树
	index$getCommentList: ({
		article_id
	}) => {
		return doRequest("GET", {
			url: "index/getCommentList",
			params: {
				article_id
			},
		});
	},

	// ---------------------------------


	// 获取精选专题
	index$get_beaut_special: () => {
		return doRequest("GET", {
			url: "index/get_beaut_special",
		});
	},
	// 获取精选课程
	index$get_beaut_course: () => {
		return doRequest("GET", {
			url: "index/get_beaut_course",
		});
	},
	// 获取栏目
	index$menus: () => {
		return doRequest("GET", {
			url: "index/menus",
		});
	},
	// 获取轮播图
	index$carousel: () => {
		return doRequest("GET", {
			url: "index/carousel",
		});
	},
	// 获取客服和公众号二维码
	index$get_erweima: () => {
		return doRequest("GET", {
			url: "index/get_erweima",
		});
	},
	// 获取课程科目
	index$get_subject: () => {
		return doRequest("GET", {
			url: "index/get_subject",
		});
	},
	// 获取荣誉证书
	index$getHonor: () => {
		return doRequest("GET", {
			url: "index/getHonor",
		});
	},
	// 获取会员卡列表
	index$get_cards: () => {
		return doRequest("GET", {
			url: "index/get_cards",
		});
	},
	//用户获取优惠券记录
	user$getCouponList: ({
		user_id,
		course_id,
		special_id
	}) => {
		return doRequest("GET", {
			url: "user/getCouponList",
			params: {
				user_id,
				course_id: course_id || '',
				special_id: special_id || ''
			},
		})
	},

};

export default baseApiHttp;